import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { ILinkedText, ILinkedTextItem } from 'src/shared/models';

const { TEXT_LINK_TEXT, TEXT_LINK_LINK } = ResourceTypeDetailEnum;

const getLinkedTextContent = ({
  resourceDetailList,
}: IResourceList): ILinkedTextItem => {
  let product = {} as ILinkedTextItem;
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case TEXT_LINK_TEXT:
          product = {
            ...product,
            title: value,
          };
          break;
        case TEXT_LINK_LINK:
          product = {
            ...product,
            link: value,
          };
          break;
      }
    });
  return { ...product };
};

export const buildChallengeTextLink = (
  resource: IResourceList
): ILinkedText => {
  const { idResource, resourceList } = resource;

  const arrContent: ILinkedTextItem[] =
    resourceList?.map((resource) => getLinkedTextContent(resource)) || [];

  return { arrContent, idResource } as ILinkedText;
};
